import Loading from "components/common/Loading";
import { useHttpContext, useHttpUtil } from "context/HttpContext";
import Stats from "libs/utils/stats";
import Tools from "libs/utils/Tools";
import { ReactNode, useEffect, useRef, useState } from "react";
import CustomImage from "components/common/CustomImage";
import Masonry from 'react-masonry-css'
import { useMockupsContext } from "pages/project/mockups/MockupsContext";

type Material = {
    mid: string,
    name: string,
    url: string,
    showUrl ?: string,
    width?: number,
    height?: number,
    status?: number,
    progress?:number,
    isChecked ?: boolean,
    file ?: File
}

interface CheckedMaterial {
    [key: string]: boolean
}


const PAGE_SIZE = 15 ;
// Media
export default function Media(props: { onImageClick: Function}){
    const httpUtil = useHttpUtil();
    const httpContent = useHttpContext();
    const mockupsContext = useMockupsContext();

    // 素材库分页索引
    const [materialPage, setMaterialPage] = useState<number>(-1);
    // 上传的素材数量(主要用来查询分页用)
    const [materialUploadedNum, setMaterialUploadedNum] = useState<number>(0);

    const [checkedMaterial, setCheckedMaterial] = useState<CheckedMaterial>({});

    const [materialList, setMaterialList] = useState<Material[]>();

    // const [uploadMaterial, setUploadMaterial] = useState<Material>();
    const [uploadMaterialList, setUploadMaterialList] = useState<Material[]>();

    const [isLoading, setIsLoading] = useState<boolean>(false);


    const listElement = useRef<HTMLDivElement>(null);

    useEffect(() => {
        materialPage > 0 && getMaterialList();
    },[materialPage]);

    useEffect(() => {
        if(mockupsContext?.isMockups && !mockupsContext.mockupsDetail?.isLogin) return ;
        if( materialPage == -1){
            setMaterialPage(1);
        }else if(materialPage > 0){
            getMaterialList()
        }
    }, [ materialPage, mockupsContext?.isMockups, mockupsContext?.mockupsDetail?.isLogin]);

    const getMaterialList = async function(){
        setIsLoading(true);
        
        const responseData = await httpUtil.post('/biz/material/list', {
            currentPage: materialPage,
            initSize: materialUploadedNum,
            pageSize : PAGE_SIZE
        })
        if(!responseData.data || materialPage == 1 && responseData.data.length == 0) {
            setMaterialPage(0);
            setMaterialList([]);
        }else{
            if(materialPage == 1){ 
                setMaterialList(responseData.data)
            }else{
                setMaterialList(materialList?.concat(responseData.data))
            }
            if(responseData.data.length < PAGE_SIZE){
                setMaterialPage(0);
            }
        } 
        setTimeout(() => {
            setIsLoading(false);
        },1500)
        
    }

    const uploadFile = async function(e: React.ChangeEvent<HTMLInputElement>){
        const files = e.target.files, len = files?.length ;
        if(len){
            const MAX_M = 20 ;

            let isHasError = false;
            const imageList: Material[] = [];
            let urls = [] ;

            const disponse = (i : number) : Promise<boolean> => {
                return new Promise((resolve: (flag: boolean) => void) => {
                    const file = files[i];
                
                    if(file.size >= MAX_M * 1024 * 1024){  // 超出提示
                        if(!isHasError){
                            isHasError = true ;
                            if(len > 1) httpContent?.response(1, `Images larger than ${MAX_M}M have been ignored`)
                            else httpContent?.response(1, `The image size exceeds the maximum limit and cannot be larger than ${MAX_M}M`);
                        }
                        resolve(true) ;
                    }
    
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        const imgData =  e.target?.result as string ;
                        imageList.push({
                            mid : new Date().getTime() + '',
                            name : 'upload',
                            status: 1,
                            progress: mockupsContext?.isMockups && !mockupsContext.mockupsDetail?.isLogin ? 100: 0,
                            file: file,
                            url: imgData,
                            showUrl: e.target?.result as string
                        })
                        urls.push(imgData);
                        resolve(true) ;
                    }
                    reader.readAsDataURL(file);
                })
                
            }

            for(let i = 0;i < len ;i ++){
                await disponse(i);
            }

            setUploadMaterialList(imageList);
            if(!mockupsContext?.isMockups || mockupsContext?.mockupsDetail?.isLogin){
                urls = [] ;
                for(let i = 0, len = imageList.length ;i < len; i ++ ){
                    const item = imageList[i];

                    let timer : NodeJS.Timeout | null = null, progress = 0;
                    const responseData = await httpUtil.upload(item.file, (p : number) => {
                        if(p == 100){
                            timer = setInterval(() => {
                                progress += 2 ;
                                if(progress > 90 && timer){
                                    return clearInterval(timer)
                                }
                                const _items = [...imageList]
                                _items[i].progress = progress ;
                                setUploadMaterialList(_items);
                            }, 200)
                        }
                    });
                    if(timer) clearInterval(timer)
                    const material = responseData.data as Material;

                    
                    const _items = [...imageList]
                    _items[i].url = material.url ;
                    _items[i].progress = 100 ;
                    setUploadMaterialList(_items);
                    urls.push(item.url);
                }

                setUploadMaterialList(undefined);
                setMaterialUploadedNum(materialUploadedNum + imageList.length)
                setMaterialList([...imageList].concat(materialList || []))
            }
            Stats.google('Uploaded');
            props.onImageClick(urls); // 一次性添加上传的所有图片
        }
    }

    const scrollContent = async function () {
        if(listElement.current && materialPage > 0 && !isLoading){
            const { scrollTop, scrollHeight, clientHeight} = listElement.current ;
            if(scrollTop + clientHeight + 20 > scrollHeight){
                setMaterialPage(materialPage + 1)
            }
        }
    }

    const checkedHandler = function(mid: string){
        const tmp = {...checkedMaterial} || {} ;
        if(tmp[mid]){
            delete tmp[mid] ;
        }else{
            tmp[mid] = true ;
        }
        setCheckedMaterial(tmp);
    }

    const deleteSelected = async function(ids?: string[]){
        if(!ids){
            ids = checkedMaterial && Object.keys(checkedMaterial) || [] ;
            if(!ids.length) return ;
        }
        
        await httpUtil.post('/biz/material/del', {
            ids: ids.join(',')
        });
        clearSelected();
        listElement.current?.scrollTo({
            top: 0
        })
        if(materialPage != 1) setMaterialPage(1);
        else getMaterialList() ;
    }

    const clearSelected = function(){
        setCheckedMaterial({});
    }

    const download = (url: string, name: string) => {
        httpUtil.download(Tools.completeUrl(url), name);
    }

    const imgDragStart = (event: React.DragEvent<HTMLImageElement>, url: string) => {
        event.dataTransfer.effectAllowed = 'copy';
        event.dataTransfer.setData('imageUrl', url);
    }

    const dragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "copy"
    }


    const buildItem = function(item : Material) : ReactNode {
        const {mid, name, url, showUrl = '', width = 0, height = 1, isChecked = checkedMaterial && checkedMaterial[mid] ? true : false} = item ;

        return <div className="relative group rounded-[10px] bg-[#EBEBEB] w-full cursor-pointer mt-[10px]" key={mid}
                style={{ 
                    aspectRatio: width / height,
                }}>
                <div className={`rounded-[10px] overflow-hidden `}
                    style={{ 
                        border: isChecked ? '2px solid #14A5FA' : '#BFBFBF'
                    }}>
                    <CustomImage loading="lazy" src={showUrl || url} alt={name} className={` w-full bg-[#FFFFFF] cursor-pointer active:cursor-default `} 
                        onClick={() => props.onImageClick(url)}
                        draggable={true}
                        onDragStart={(event) => { imgDragStart(event, url) }}
                        />
                </div>
                <div
                    style={{
                        backgroundColor: isChecked ? '#14A5FA' : '#FFFFFF',
                        borderWidth: isChecked ? '0px' : '1px',
                        display: checkedMaterial && Object.keys(checkedMaterial).length ? 'block': 'none'
                    }} 
                    className="absolute top-[10px] left-[10px] p-[1px] border border-[#BFBFBF] rounded-[5px] w-[20px] h-[20px] group-hover:!block hidden"
                    onClick={() => {
                        checkedHandler(mid)
                    }}>
                {
                    isChecked && <CustomImage src="/icon/icon-checked.png"/>
                    || <CustomImage src="/icon/icon-not-checked.png" className="group-hover:block hidden"/>
                }
                </div>

            </div>
    }



    return (
        <div className="absolute h-full top-[0px] shadow-lg bg-[#FFFFFF] xl:w-[320px] xl:left-[100px] w-[200px] left-[70px]"
            onDragOver={event => dragOver(event)}>
            <div className="relative flex flex-col h-full w-full p-[10px] overflow-y-auto z-[10001]  bg-[#FFFFFF]"
                ref={listElement}
                onScroll={() => scrollContent()}>
                <div className="flex p-[5px] pb-[0px]">
                    <div id="step1_element" className="flex flex-col px-[10px] xl:px-[20px] relative w-full rounded-[10px] bg-gradient-to-r from-[#14A5FA] to-[#10F28D] cursor-pointer text-[#FFFFFF] text-[14px] xl:py-[15px] py-[9px]">
                        <div className="flex items-center justify-center gap-[10px]">
                            <CustomImage src="/icon/icon-editor-upload.png" className="w-[20px]" />
                            <span className="small-txt">Upload</span>
                        </div>
                        <p className="text-center text-[10px] xl:text-[12px] mt-[5px]">Please upload your product images <br/> and design images. (Batch upload allowed)</p>
                        <input type="file" multiple className="absolute left-0 top-0 w-full h-full opacity-0 cursor-pointer triggerEventElement" 
                            accept="image/*"
                            onClick={() => Stats.google('Upload')}
                            onChange={(e) => uploadFile(e)}/>
                    </div>
                </div>
                <Masonry
                    breakpointCols={2}
                    className="flex gap-[10px]"
                    columnClassName="">
                    {
                        uploadMaterialList?.map((item: Material) => (
                            <div key={item.mid} className="rounded-[10px] relative mt-[10px]">
                                <CustomImage src={item.url} alt={item.name} className={`rounded-[10px] cursor-pointer`} 
                                     onClick={() => props.onImageClick(item.url)}/>
                                {
                                    item.progress !== undefined && item.progress < 100 &&
                                    <div className="absolute w-full h-full left-0 top-0 bg-[#000000]/[0.5] rounded-[10px] px-[18px] flex items-center justify-center">
                                        <div className="w-full h-[10px] relative bg-[#FFFFFF] rounded-[10px]">
                                            <div style={{
                                                width : `${item.progress}%`
                                            }} className="absolute scale-[1.02] transition-[width] ease-in-out delay-150 left-0 top-0 w-[0%] h-full rounded-[10px] bg-[#14A5FA]"></div>
                                        </div>
                                    </div>
                                }
                            </div>
                        ))
                    }
                    {
                        materialList?.map((item: Material) => (
                            buildItem(item)
                        ))
                    }
                </Masonry>
                {
                    isLoading && <Loading />
                }
                {
                    !isLoading && !uploadMaterialList?.length && (!materialList || !materialList.length) &&
                    <div className="text-center mt-[40%] flex flex-col justify-center items-center">
                        <CustomImage src="/icon/icon-empty.png" className="w-[80%]" />
                        <p className="text-[#BFBFBF] font-semibold text-[16px] xl:text-[20px]">No files</p>
                    </div>
                }
                {
                    /** 先取消展示 */
                    // !isLoading && !uploadMaterial && (!materialList || !materialList.length) ?
                    //     <div className="flex w-full h-full justify-center xl:px-[10px]">
                    //         <div className="small-txt mt-[10px] pb-[30px]">
                    //             <p>⭐ To design a mockup, upload at least two images:</p>
                    //             <ul className="list-decimal ml-[20px]">
                    //                 <li className="mt-[10px]">Upload a product image and click "Mockup" to generate the model.</li>
                    //                 <li className="mt-[10px]">Upload a design pattern and drag it into the model for editing and design.</li>
                    //                 <li className="mt-[10px]">Click "Download" to obtain the high-quality design mockup.</li>
                    //             </ul>

                    //             <p className="mt-[10px] xl:mt-[20px] font-semibold">For example:</p>
                    //             <div className="flex flex-wrap justify-center mt-[5px] xl:mt-[20px]">
                    //                 <div className="basis-1/2">
                    //                     <div className="mr-[5px] rounded-[10px] text-center border">
                    //                         <CustomImage src="/case/introduction-1.png" className="max-w-[100%] rounded-t-[10px]" />
                    //                         <span className="my-[3px] block">Product Images</span>
                    //                     </div>
                    //                 </div>
                    //                 <div className="basis-1/2">
                    //                     <div className="ml-[5px] rounded-[10px] text-center border">
                    //                         <CustomImage src="/case/introduction-2.png" className="max-w-[100%] rounded-t-[10px]" />
                    //                         <span className="my-[3px] block">Design pattern</span>
                    //                     </div>
                    //                 </div>
                    //                 <div className="basis-1/2 mt-[5px] xl:mt-[15px]">
                    //                     <div className="rounded-[10px] text-center border">
                    //                         <CustomImage src="/case/introduction-3.png" className="max-w-[100%] rounded-t-[10px]" />
                    //                         <span className="my-[3px] block">Mockup</span>
                    //                     </div>
                    //                 </div>
                    //             </div>

                    //             <span className="text-[#7B7B7B] text-[10px] xl:text-[12px] mt-[15px] block">If you don't have the required images at the moment, you can click on the "Project" tutorial and follow the steps to edit the sample images on the canvas.</span>
                    //         </div>
                    //     </div>
                    // : null
                }
            </div>
            {
                checkedMaterial && Object.keys(checkedMaterial).length ?
                    <div className="absolute w-full px-[20px] bottom-[15px] left-0 z-[10002]">
                        <div className="w-full border py-[10px] px-[15px] border-[#D9D9D9] rounded-[5px] bg-[#FFFFFF] flex items-center">
                            <span className="text-[14px]">{Object.keys(checkedMaterial).length} selected</span>
                            <div className="grow flex justify-center ">
                                <CustomImage src="/icon/icon-delete.png" className="w-[25px] cursor-pointer " 
                                    onClick={() => deleteSelected()} />
                            </div>
                            <div className="">
                                <CustomImage src="/icon/icon-close.png" className="w-[20px] cursor-pointer" 
                                    onClick={() => clearSelected()} />
                            </div>
                        </div>
                    </div>  
                : null
            }
        </div>
    )
}

